export const locale = {
  lang: 'de',
  data: {
    'PERFIL_USUARIO': {
      'TITULO': 'Mein Profil',
      'ENLACES': {
        'configuracion': 'Account Einstellungen',
        'notificaciones': 'Benutzerbenachrichtigungen',
        'mensajes': 'Empfangene Nachrichten'
      },
      'PAGINAS': {
        'configuracion': {
          'TITULO': 'Account Einstellungen',
          'OPCIONES': {
            'CAMBIARMAIL': {
              'TITULO': 'Ändern Sie die E-Mail',
              'SUBTITULO': 'Sie können die E-Mail-Adresse Ihres Kontos ändern',
              'INPUTS': {
                'MAIL': 'neue E-Mail-Adresse',
                'TOKEN': 'Verifizierungs-Schlüssel',
                'PASS': 'Neues Kennwort',
                'CONFIRMPASS': 'Kennwort bestätigen'
              },
              'BOTONES': {
                'CAMBIAMAIL': 'Ändern Sie die E-Mail',
                'VERTOKEN': 'Code überprüfen',
                'FINALMAIL': 'E-Mail Adresse ändern',
              }
            },
            'CAMBIARPASS': {
              'TITULO': 'Kennwort ändern',
              'SUBTITULO': 'Sie können Ihr Kontopasswort ändern',
              'BOTONES': {
                'FINALPASS': 'Kennwort ändern'
              }
            },
            'AUTENTICACION': {
              'TITULO': 'Zweistufige Authentifizierung',
              'SUBTITULO': 'Sie können die Sicherheit Ihres Kontos erhöhen, indem Sie die zweistufige Authentifizierung aktivieren',
              'BOTONES': {
                'ACTIVAR': 'aktivieren Sie',
                'DESACTIVAR': 'Deaktivieren'
              }
            }
          }
        }
      },
      'MODALES': {
        'CAMBIARMAIL_PASO1_OK': 'An die angegebene E-Mail-Adresse wurde eine Nachricht mit einem Bestätigungscode gesendet. Geben Sie den erhaltenen Bestätigungscode ein, um den Vorgang fortzusetzen',
        'CAMBIARMAIL_PASO1_NOTOK': 'Kann nicht fortfahren, die eingegebene E-Mail ist bereits im System registriert',
        'CAMBIARMAIL_PASO1_SAME': 'Kann nicht fortfahren, die eingegebene E-Mail ist dieselbe wie das Konto derzeit',
        'CAMBIARMAIL_PASO2_OK': 'Der Bestätigungscode ist korrekt, um fortzufahren, müssen Sie unten ein neues Passwort eingeben',
        'CAMBIARMAIL_PASO2_NOTOK': 'Der Bestätigungscode ist falsch, bitte überprüfen Sie, ob Sie ihn richtig eingegeben haben und überprüfen Sie ihn erneut',
        'CAMBIARMAIL_PASO3_NOTOK': 'Fortfahren nicht möglich, Passwörter stimmen nicht überein, bitte geben Sie sie erneut korrekt ein',
        'CAMBIARMAIL_PASO3_OK': 'Die Kontodaten wurden korrekt aktualisiert, um den Vorgang abzuschließen wird die Sitzung geschlossen, betreten Sie die Plattform erneut mit den neuen Zugangsdaten',
        'CAMBIAPASS_OK': 'Das Kontopasswort wurde erfolgreich aktualisiert',
        'CAMBIAPASS_NOTOK': 'Fortfahren nicht möglich, Passwörter stimmen nicht überein, bitte geben Sie sie erneut korrekt ein',
        'AUTHOK': 'Authentifizierungsstatus erfolgreich aktualisiert'
      }
    },
    'PROFILE': {
      'MENU_TITLE':'Schließen',
      'MYPROFILLE':'Mein Profil',

      'TITLE':'Passwort ändern',
       'BTNBACK':'Zurück',
       'MENUTITLE':'Menü',
       'MENÜ':{
         'OPC1':'Meine Daten'
       },
       ' NAME':'Name',
       'EMAIL':'E-Mail',
       'CODE':'Verifizierungscode',
       'NEWPASS':'Neues Passwort',
       'REPASS':'Passwort erneut eingeben',
       'CHANGE':'Passwort ändern',
       'SENDCODE':'Verifizierungscode senden',
       'CHECKCODE':'Code verifizieren',
       'ERROR':{
        'ERROR01':'Erforderliches Feld',
        'ERROR02':'Fehler, etwas ist passiert',
        'ERROR03':'Der Code stimmt nicht überein',
        'ERROR04':'Passwörter stimmen nicht überein',
        'ERROR05':'Muss mindestens 3 Zeichen lang sein',
        'ERROR06':'Die E-Mail existiert bereits, bitte versuchen Sie es mit einer anderen',
        'ERROR07':'Firmenname stimmt nicht überein'
      },
      'SUCCESS':{
        'OK':'Ok',
       'MESESAGE1':'Daten korrekt aktualisiert',
       'MESESAGE2':'Code gesendet ... Bitte prüfen Sie Ihre E-Mail',
       'MESESAGE3':'Korrekter Code'
      }
    }
  }
};
